export const UPDATE_NEWSFEED_LIST = "top/UPDATE_NEWSFEED_LIST";
export const APPEND_NEWSFEED_LIST = "top/APPEND_NEWSFEED_LIST";
export const REMOVE_NEWSFEED_POST = "top/REMOVE_NEWSFEED_POST";
export const UPDATE_ADMIN_NOTICE = "top/UPDATE_ADMIN_NOTICE";
export const UPDATE_POST_IMAGE_SOCKET = "top/UPDATE_POST_IMAGE_SOCKET";
export const UPDATE_POST_VIDEO_SOCKET = "top/UPDATE_POST_VIDEO_SOCKET";
